module.exports = __webpack_public_path__ + "static/media/download.f66e0b1f.png";